import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { sidebarReducer } from '@shared/api/reduxToolkit';
import { SIDEBAR_KEY } from '@shared/constants';

const sidebarPersistConfig = {
	key: SIDEBAR_KEY,
	version: 1,
	storage,
	whitelist: ['isMini'],
};

export const persistedSidebarReducer = persistReducer(sidebarPersistConfig, sidebarReducer);
